import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import initialUser from "../context/InitialUserContext";
import { auth, db } from "../firebase";

export const userLogout = async () => {
  const auth = getAuth();

  try {
    await signOut(auth);
  } catch (error) {
    console.log("there was an error signing out, ", error);
  }
};

// checks if we have a logged in firebase user and sets user accordingly
export const setCurrentUser = (setUser) => {
  const auth = getAuth();

  onAuthStateChanged(auth, async (user) => {
    // if the user is logged out, reset the user context to default
    if (!user) return setUser(initialUser);

    // user is logged in, update the user context with their details
    const userDetails = await getUserById(user.uid);

    setUser({ ...userDetails.data() });
  });
};

export const registerUser = async (userData) => {
  const { email, password, childName, isAdmin, schoolId } = userData;
  const auth = getAuth();

  try {
    // create auth user
    const { user } = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    // create user in firestore
    const docRef = doc(db, "users", user.uid);

    await setDoc(docRef, {
      childName,
      uid: auth.currentUser.uid,
      energyLevel: 50,
      fuelLevel: 55,
      healthLevel: 60,
      schoolId: schoolId,
      schoolName: "Flexbox Academy",
      parent: { name: "Gertrude", email: "gertie@yahoo.com" },
      isAdmin,
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/save-oom-oxna.appspot.com/o/avatars%2FAvatar03.svg?alt=media&token=6d955437-a514-427e-854b-c775acbeffa3",
      roundsPlayed: [],
    });

    return {
      isSuccess: true,
    };
  } catch ({ code, message }) {
    console.error(`Error code: ${code}. Error message: ${message}`);
    return {
      isSuccess: false,
      error: "Email already in use",
    };
  }
};

/**
 * Gets a user object using the userId.
 * @param {*} userId
 * @returns
 */
const getUserById = async (userId) => {
  const docRef = doc(db, "users", userId);
  return await getDoc(docRef);
};

// Gets all users for a specific school
export const getUsersForSchool = async (schoolId) => {
  const usersCol = collection(db, "users");
  const usersSnapshot = await getDocs(usersCol);
  const userList = usersSnapshot.docs
    .map((doc) => doc.data())
    .filter((doc) => doc.schoolId === schoolId && !doc.isAdmin);
  return userList;
};

export const updateUserAvatar = async (imgUrl) => {
  const uid = auth.currentUser.uid;

  const docRef = doc(db, "users", uid);
  await updateDoc(docRef, { avatar: imgUrl });
};

export const setEnergyToFull = async (uid) => {
  const docRef = doc(db, "users", uid);
  await updateDoc(docRef, { energyLevel: 100 });
};
